import React, { useEffect, useState, useRef } from "react";
import {
  QUERY_GET_TOURNAMENT_LEADERBOARD,
  QUERY_PARTICIPATE_IN_TOURNAMENT,
} from "common/src/graphql/queries";
import { TournamentPopover } from "../modal/TournamentPopover";
import { printAmount } from "common/src/helpers/functions";
import { useApolloClient } from "@apollo/client";
import "../../../plc/src/data/scss/layout/tables.scss";
import { useTranslation } from "react-i18next";

const TournamentTable = ({
  playerCurrency,
  showAll,
  server,
  displayName,
  tournamentGame,
  showTournamentPopover,
  setShowTournamentPopover,
  skin,
}) => {
  const apolloClient = useApolloClient();
  const [tournamentLeaderboard, setTournamentLeaderboard] = useState([]);
  const tournamentDescription = useRef("text_without_tournament_description");
  const { t } = useTranslation("");

  useEffect(() => {
    let tournamentPrizes = [
      "first",
      "second",
      "third",
      "fourth",
      "tenth",
      "fiftieth",
      "twentieth",
    ];
    async function getTounaments(internalID) {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_PARTICIPATE_IN_TOURNAMENT,
        variables: { gameID: internalID },
      });
      if (loading) return <h3>Loading ...</h3>;
      if (errors) return <h1>`Error: ${errors}`</h1>;
      tournamentDescription.current =
        data.participateInTournament.tournaments.length > 0
          ? data.participateInTournament.tournaments[0].tournamentDescription
          : "text_without_tournament_description";
      data.participateInTournament.tournaments.forEach((element) => {
        let uuid = element.uniqueID;
        let prizeValues = element.prizes;
        let tournamentName = element.tournamentName;
        let currency = playerCurrency === undefined ? "eur" : playerCurrency;
        let prizes = [];

        //console.log(prizeValues);
        tournamentPrizes.forEach((prize) => {
          prizes.push({
            [prize]: prizeValues[prize].filter(
              (el) => el.currency === currency
            )[0],
          });
        });
        //  uuid, tournamentName, prizes, currency ;
        //console.log(prizes);
        GetTournamentLeaderboard(uuid, tournamentName, prizes, currency);
      });

      return null;
    }
    if (tournamentGame !== null) getTounaments(tournamentGame);

    async function GetTournamentLeaderboard(
      uniqueID,
      tournamentName,
      prizes,
      currency
    ) {
      const { errors, data } = await apolloClient.query({
        query: QUERY_GET_TOURNAMENT_LEADERBOARD,
        variables: {
          uniqueID: uniqueID,
          currency: currency,
        },
        //fetchPolicy: "cache-first",
      });
      if (errors) return <h1>`Error: ${errors}`</h1>;
      let tournamentLead = data.getTournamentLeaderboard.leaderboard;

      //console.log("vrednost " + tournamentLead);
      let i = 1;
      tournamentLead.forEach((element) => {
        element["tournamentName"] = tournamentName;
        if (i === 1) {
          element["prize"] = prizes[0].first;
        } else if (i === 2) {
          element["prize"] = prizes[1].second;
        } else if (i === 3) {
          element["prize"] = prizes[2].third;
        } else if (i < 10) {
          element["prize"] = prizes[3].fourth;
        } else if (i === 10) {
          element["prize"] = prizes[4].tenth;
        }
        i++;
      });
      //console.log("vrednost " + JSON.stringify(tournamentLead));
      setTournamentLeaderboard(tournamentLead);
      return null;
    }
  }, [apolloClient, tournamentGame, playerCurrency]);

  return (
    <>
      {skin === "yet" && (
        <tr>
          <th>{t("label_leaderboard")}</th>
          <th>{t("label_round")}</th>
        </tr>
      )}
      {tournamentLeaderboard.length > 0 &&
        tournamentLeaderboard.map((el, index) => (
          <tr className={!showAll && index > 10 ? "hidden" : ""} key={index}>
            <th>{el.leaderboard}</th>
            {displayName && <th>{el.tournamentName}</th>}
            <th>
              {skin === "yet"
                ? el.numberOfBets && el.numberOfBets
                : el.prize &&
                  printAmount(
                    el.prize.value,
                    el.prize.currency,
                    server.currencies,
                    true
                  )}
            </th>
          </tr>
        ))}
      <TournamentPopover
        showModal={showTournamentPopover}
        handleCancel={() => setShowTournamentPopover(false)}
        tournamentDescription={tournamentDescription.current}
        skin={skin}
      />
    </>
  );
};

export default TournamentTable;
